import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Users, Briefcase, CalendarCheck, FileText } from "lucide-react"; // Icons
import axios from "axios";
import api from "../../utils/api";

// Icon map

// Animations
const cardVariants = {
  hidden: { opacity: 0, scale: 0.9, y: 20 },
  visible: (i) => ({
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.5 },
  }),
};

function Dashboard() {
  const [employeeCount, setEmployeeCount] = useState(0);
  const cards = [
    {
      title: "Employees",
      count: employeeCount,
      icon: <Users size={50} className="text-white" />,
      bg: "bg-blue-600",
    },
    {
      title: "Leave reports",
      count: 0,
      icon: <CalendarCheck size={50} className="text-white" />,
      bg: "bg-green-500",
    },
    {
      title: "Events",
      count: 0,
      icon: <Briefcase size={50} className="text-white" />,
      bg: "bg-purple-500",
    },
    {
      title: "Reports",
      count: 0,
      icon: <FileText size={50} className="text-white" />,
      bg: "bg-orange-500",
    },
  ];

  useEffect(() => {
    api
      .get(`/auth/count/employees`)
      .then((response) => {
        console.log(response.data);
        setEmployeeCount(response.data);
      })
      .catch((error) => {
        console.error("Error fetching employee count:", error);
        setEmployeeCount(2);
      });
  }, []);
  return (
    <>
      <div className="flex sm:flex-row flex-col justify-between pt-10 gap-2">
        {cards.map((card, index) => (
          <motion.div
            key={index}
            className={`flex-1 min-h-[100px] p-6 rounded-xl shadow-md text-white sm:min-h-[180px] ${card.bg} `}
            initial="hidden"
            animate="visible"
            custom={index}
            variants={cardVariants}
          >
            <div className="flex flex-col justify-between h-full">
              <div className="flex justify-between items-start">
                <h2 className="text-lg font-medium">{card.title}</h2>
                {card.icon}
              </div>
              <p className="text-3xl font-bold mt-auto">{card.count}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </>
  );
}

export default Dashboard;
